import request from '@/utils/request'

/**
 *查询加密狗授权用户分页
 * @param {*} params
 * @returns
 */
export const getDongleUserPage = (params) => {
  return request({
    url: '/sys/v1/dongleUser/page-plus',
    params
  })
}

/**
 * 查询加密狗授权用户
 * @param {*} params
 * @returns
 */
export const getDongleUser = (id) => {
  return request({
    url: `/sys/v1/dongleUser/${id}`
  })
}

/**
 * 查询某个加密狗用户开通多少功能
 * @param {*} params
 * @returns
 */
export const findDongleUserModule = (params) => {
  return request({
    url: '/sys/v1/dongleUser/findDongleUserModule',
    params
  })
}

/**
 * 新增加密狗用户
 * @param {*} data
 * @returns
 */
export const insertDongleUser = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/dongleUser/insertDongleUser',
    data
  })
}

/**
 * 修改加密狗用户信息
 * @param {*} data
 * @returns
 */
export const updateDongleUser = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/dongleUser',
    data
  })
}

/**
 * 删除加密狗用户
 * @param {*} id
 * @returns
 */
export const deleteDongleUser = (id) => {
  return request({
    method: 'DELETE',
    url: `/sys/v1/dongleUser/deleteDongleUser/${id}`
  })
}

/**
 * 新增加密狗用户授权功能
 * @param {*} id
 * @returns
 */
export const insertDongleUserModule = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/dongleUser/insertDongleUserModule',
    data
  })
}

/**
 * 修改加密狗用户授权功能
 * @param {*} data
 * @returns
 */
export const updateDongleUserModule = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/dongleUser/updateDongleUserModule',
    data
  })
}

/**
 * 删除加密狗用户授权功能
 * @param {*} id
 * @returns
 */
export const deleteDongleUserModuleById = (id) => {
  return request({
    method: 'DELETE',
    url: `/sys/v1/dongleUser/deleteDongleUserModuleById/${id}`
  })
}

/**
 * 查询加密狗用户历史审批变动记录分页列表
 * @param {*} params
 * @returns
 */
export const findDongleUserApprovalHisPage = (params) => {
  return request({
    url: '/sys/v1/dongleUser/findDongleUserApprovalHisPage',
    params
  })
}

/**
 *通过历史记录id查询某个加密狗应用下历史记录信息
 * @param {*} params
 */
export const findDongleUserModuleByHistoryId = (params) => {
  return request({
    url: '/sys/v1/dongleUser/findDongleUserModuleByHistoryId',
    params
  })
}
